// extracted by mini-css-extract-plugin
export default {"input":"Input_input__PII0D","root":"Input_root__qlKhN","mark":"Input_mark__G8NA2"};